import { render, staticRenderFns } from "./PlaylistPreview.vue?vue&type=template&id=88a0b828&scoped=true"
import script from "./PlaylistPreview.vue?vue&type=script&lang=js"
export * from "./PlaylistPreview.vue?vue&type=script&lang=js"
import style0 from "./PlaylistPreview.vue?vue&type=style&index=0&id=88a0b828&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a0b828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88a0b828')) {
      api.createRecord('88a0b828', component.options)
    } else {
      api.reload('88a0b828', component.options)
    }
    module.hot.accept("./PlaylistPreview.vue?vue&type=template&id=88a0b828&scoped=true", function () {
      api.rerender('88a0b828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/playlist/PlaylistPreview.vue"
export default component.exports